module.exports = __webpack_public_path__ + "static/media/icons.0ab54153.woff2";